export const blogInitialState = {
  content: {
    facts: {
      data: {},
      isError: null,
      isLoading: false,
      isDataLoaded: false,
      languageCode: "",
    },

    blog: {
      data: {},
      isError: null,
      isLoading: false,
      isDataLoaded: false,
    },
  },
};
